import React from "react";
import { Box, Typography } from "@mui/material";
import { Black, DarkGrey, Primary, White, White01 } from "src/styles/color";
import font from "src/styles/font";
import { convertIntToCurrency } from "src/common";

const SalesSellerChart = ({ data, selectedSeller, onSelect }) => {
  const top1Seller = data[0];
  const otherSellers = data.slice(1);

  return (
    <Box bgcolor="#fff" borderRadius={4}>
      <Typography variant="h6" fontWeight={700}>
        ยอดขายรายร้านค้า
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={3}>
        กดเลือกรายการจะแสดงกราฟด้านล่าง
      </Typography>
      {data.length !== 0 ? (
        <Box
          sx={{
            display: "flex",
            alignItems: {
              xs: "center",
              sm: "flex-start",
            },
            justifyContent: "space-between",
            flexDirection: { xs: "column", sm: "row" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              maxWidth: { xs: "100%", md: "40%" },
              flex: 1,
              p: 2,
              borderRadius: 4,
              "&:hover": {
                backgroundColor: White01,
                color: Primary,
                fontWeight: 600,
              },
              ...(top1Seller?._id === selectedSeller?._id && {
                backgroundColor: White01,
                color: Primary,
                fontWeight: 600,
              }),
              transition: "background-color 0.3s ease",
              cursor: "pointer",
            }}
            onClick={() => {
              onSelect(top1Seller);
            }}
          >
            <Box
              style={{
                position: "relative",
                width: 132,
                height: 132,
                lineHeight: 0,
              }}
            >
              <img
                src={top1Seller?.profileImage}
                style={{
                  padding: "6px",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  zIndex: 1,
                  objectFit: "cover",
                }}
                alt={top1Seller?.brandName}
              />
              <svg
                width="132"
                height="142"
                viewBox="0 0 132 142"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  zIndex: 2,
                  position: "absolute",
                }}
              >
                <circle
                  cx="66"
                  cy="66"
                  r="63.5"
                  stroke="#EB918B"
                  stroke-opacity="0.32"
                  stroke-width="5"
                />
                <circle
                  cx="66"
                  cy="66"
                  r="61"
                  stroke="#E13B30"
                  stroke-width="2"
                />
                <path
                  d="M53.1526 132.165L43.3843 141.193C42.8083 141.727 41.7762 141.273 41.6371 140.428L41.5056 139.648L41.2776 138.287L40.7944 135.401C40.7171 134.943 40.3498 134.547 39.8937 134.44L37.211 133.79L35.8658 133.464L34.9149 133.233C34.076 133.029 33.7011 131.976 34.277 131.442L44.0453 122.414C44.4319 122.056 45.0736 122.126 45.4872 122.564L53.1062 130.716C53.516 131.154 53.5391 131.799 53.1526 132.157V132.165Z"
                  fill="#EB918B"
                />
                <path
                  d="M78.8473 132.165L88.6156 141.193C89.1915 141.727 90.2236 141.273 90.3628 140.428L90.4942 139.648L90.7223 138.287L91.2055 135.401C91.2828 134.943 91.65 134.547 92.1062 134.44L94.7889 133.79L96.1341 133.464L97.085 133.233C97.9238 133.029 98.2988 131.976 97.7228 131.442L87.9545 122.414C87.568 122.056 86.9263 122.126 86.5127 122.564L78.8937 130.716C78.4839 131.154 78.4607 131.799 78.8473 132.157V132.165Z"
                  fill="#EB918B"
                />
                <path
                  d="M92.222 112.987C91.893 112.382 91.2518 112 90.5605 112H41.4545C40.7592 112 40.1221 112.377 39.7931 112.987L36.5743 118.889C36.3162 119.362 36.2745 119.921 36.4577 120.427L40.0513 130.311C40.2303 130.8 40.6009 131.19 41.0756 131.397L65.2518 141.844C65.7306 142.052 66.2761 142.052 66.7591 141.844L90.9353 131.397C91.4142 131.19 91.7848 130.796 91.9596 130.311L95.5532 120.427C95.7364 119.921 95.6947 119.362 95.4366 118.889L92.2178 112.987H92.222Z"
                  fill="#E13B30"
                />
                <path
                  d="M90.3691 115.062C90.0984 114.565 89.5737 114.254 89.0033 114.254H43.0119C42.4415 114.254 41.9168 114.565 41.6461 115.062L39.002 119.911C38.7896 120.3 38.7563 120.761 38.9062 121.175L41.8585 128.471C42.0043 128.873 42.3082 129.197 42.6996 129.362L65.3851 138.781C65.7807 138.951 66.2262 138.951 66.6218 138.781L89.3072 129.777C89.6987 129.607 90.0068 129.284 90.1484 128.885L93.1006 121.175C93.2505 120.761 93.2172 120.296 93.0049 119.911L90.3607 115.062H90.3691Z"
                  fill="white"
                />
                <path
                  d="M64.9023 122.457L62.5823 124.137V121.801L65.3023 119.801H67.3343V130.985H64.9023V122.457Z"
                  fill="#252525"
                />
              </svg>
              <img
                src="/gold_cup.png"
                style={{
                  position: "absolute",
                  bottom: -10,
                  right: -10,
                  width: 47,
                  height: 47,
                  zIndex: 3,
                }}
                alt="gold_cup"
              />
            </Box>
            <Typography
              variant="body2"
              sx={{
                mt: 2,
                fontWeight: 600,
                color: Black,
                transition: "all 0.3s ease",
                ...(top1Seller?._id === selectedSeller?._id && {
                  color: Primary,
                }),
              }}
            >
              {top1Seller.brandName}
            </Typography>
            <Box
              sx={{
                minWidth: 120,
                height: 32,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: White,
                fontSize: font.size.md,
                fontWeight: 600,
                mt: 1.5,
                px: 2,
                borderRadius: 6,
                backgroundColor: DarkGrey,
                whiteSpace: "nowrap",
                transition: "all 0.3s ease",
                ...(top1Seller?._id === selectedSeller?._id && {
                  backgroundColor: Primary,
                }),
              }}
            >
              ฿ {convertIntToCurrency(top1Seller.value)}
            </Box>
          </Box>
          <Box
            sx={{
              width: "100%",
              maxWidth: { xs: "100%", md: "60%" },
              flex: 1,
              p: 1,
              pt: 0,
            }}
          >
            <ol
              start={2}
              style={{
                marginBlock: 0,
              }}
            >
              {otherSellers.map((item, index) => (
                <li key={index}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    gap={2}
                    sx={{
                      ml: 1,
                      py: 1,
                      px: 2,
                      mb: 1,
                      borderRadius: 4,
                      color: DarkGrey,
                      fontWeight: 500,
                      "&:hover": {
                        backgroundColor: White01,
                        color: Primary,
                        fontWeight: 600,
                      },
                      ...(item?._id === selectedSeller?._id && {
                        backgroundColor: White01,
                        color: Primary,
                        fontWeight: 600,
                      }),
                      transition: "background-color 0.3s ease",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      onSelect(item);
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: {
                          xs: `${font.size.xs} !important`,
                          md: `${font.size.sm} !important`,
                        },
                        maxWidth: { xs: 96, md: 130 },
                        textAlign: "left",
                        color: "inherit",
                        fontWeight: "inherit",
                      }}
                    >
                      {item.brandName}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: {
                          xs: `${font.size.xs} !important`,
                          md: `${font.size.sm} !important`,
                        },
                        maxWidth: { xs: 96, md: 140 },
                        textAlign: "left",
                        color: "inherit",
                        fontWeight: "inherit",
                      }}
                    >
                      ฿ {convertIntToCurrency(item.value)}
                    </Typography>
                  </Box>
                </li>
              ))}
            </ol>
          </Box>
        </Box>
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height={200}
        >
          <Typography variant="body2" color={DarkGrey}>
            ไม่มีข้อมูล
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default SalesSellerChart;
